import axios from "axios";

// Configuración de la URL base
const apiUrl = process.env.REACT_APP_API_BASE_URL || "https://bachillerdigital.daule.gob.ec/api/";

// Validar que la URL use HTTPS
if (!apiUrl.startsWith('https://') && process.env.NODE_ENV === 'production') {
  console.error('Error: La API debe usar HTTPS en producción');
}

// Configuración de Axios con medidas de seguridad
const instance = axios.create({
  baseURL: apiUrl,
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
    "X-Content-Type-Options": "nosniff",
    "X-Frame-Options": "DENY"
  },
  timeout: 10000, // 10 segundos de timeout
  withCredentials: false, // Para manejar cookies de autenticación - false DEV
  httpsAgent: new (require('https').Agent)({  
    rejectUnauthorized: process.env.NODE_ENV === 'production',
    minVersion: 'TLSv1.2' // Forzar versión mínima de TLS
  })
});

// Interceptor para manejar errores de red
instance.interceptors.response.use(
  response => response,
  error => {
    const status = error && error.response && error.response.status;
    // No loguear 401/404 para evitar ruido en consola cuando son parte del flujo normal
    if (status === 401 || status === 404) {
      return Promise.reject(error);
    }
    if (error.response) {
      console.error('Error en la respuesta:', error.response.status, error.response.data);
    } else if (error.request) {
      console.error('No se recibió respuesta del servidor');
    } else {
      console.error('Error al configurar la petición:', error.message);
    }
    return Promise.reject(error);
  }
);

export default instance;

//EstudianteList, TabletEntrega